import Sider from "antd/es/layout/Sider";
import { useState } from "react";
// import { TooltipMenu } from "../../common/tootltip/StyledTooltip";
// import styled from "@emotion/styled";
import {
  AdminActive,
  DashboardActive,
  LogoAdmin,
  LogoMaster,
  MasterActive,
  OrderActive,
  ReportActive,
  SetupActive,
} from "../../asset/icons";
import {
  SetupIcon,
  OrderIcon,
  MasterIcon,
  UserManagementIcon,
  ChevronUpSidebar,
  DepotConfigurationIcon,
  ChevronDownSidebar,
  UserManagementIconInactive,
  IconCustomer,
  IconFleet,
  IconFleetRed,
  IconSellerDistributor,
  ProfileConfigurationIcon,
  ProfileConfigurationIconRed,
  IconOrderRequest,
  IconShippingCostPayment,
  IconGromartOrder,
  IconInvoice,
  RoutesIconRed,
  RoutesIcon,
  ReportIcon,
  IconLogReport,
  IconReport,
  IconReportRed,
} from "../../asset";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant/routeConstant";
import { Tooltip } from "antd";
import ModalConfirmLeave from "../modal/ModalConfirmLeave";
import { useDispatch, useSelector } from "react-redux";
import { permissionButton } from "../../util/Util";
import { resetGlobalMSSValue } from "../../util/resetGlobalMSSvalue";
import { resetValueGlobalDDS } from "../../util/resetValueGlobalDDS";
import { resetAllGlobalValueMultipleSelect } from "../../util/resetAllValueMultipleSelect";
import { setGlobalErrors } from "../../store/reducer/globalErrors.reducers";

export const Sidebar = () => {
  const dispatch = useDispatch();

  const { confirmLeavePage } = useSelector((state) => state.page);
  const [isChecked, setIsChecked] = useState(false);
  const [isMenu, setIsmenu] = useState("");
  const [subMenu, setSubMenu] = useState("");
  const location = useLocation();
  const { menu, permission } = useSelector((state) => state.auth);

  const setMenu = (menu) => {
    resetGlobalMSSValue(dispatch);
    resetValueGlobalDDS(dispatch);
    resetAllGlobalValueMultipleSelect(dispatch);
    dispatch(setGlobalErrors({}));
    if (isMenu !== "" || isMenu === "") {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }

    if (menu === isMenu) {
      setIsChecked(false);
    }

    if (menu === isMenu && isChecked === false) {
      setIsChecked(true);
    }

    setIsmenu(menu);
  };
  console.log("CHECK PERMISSION", permission);
  console.log(
    "CHECK PERMISSION BUTTON",
    permissionButton(permission, "view", "alltrip", "order")
  );

  const selectSubMenu = (menu) => {
    resetGlobalMSSValue(dispatch);
    resetValueGlobalDDS(dispatch);
    resetAllGlobalValueMultipleSelect(dispatch);
    dispatch(setGlobalErrors({}));
    if (menu === subMenu) {
      setSubMenu("");
    } else {
      setSubMenu(menu);
    }
  };

  const [showConfirm, setShowConfirm] = useState(false);
  const [routings, setRoutings] = useState();
  const navigate = useNavigate();

  const actionLeave = (url) => {
    resetGlobalMSSValue(dispatch);
    resetValueGlobalDDS(dispatch);
    resetAllGlobalValueMultipleSelect(dispatch);
    dispatch(setGlobalErrors({}));
    setRoutings(url);
    if (confirmLeavePage) {
      setShowConfirm(true);
    } else {
      navigate(url);
      setShowConfirm(false);
      setIsChecked(false);
    }
  };

  console.log("menu", menu);

  return (
    <>
      <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={routings}
      />
      <div style={{ width: "72px" }}>
        <Sider
          collapsed={true}
          theme="light"
          width={256}
          collapsedWidth={72}
          style={{
            backgroundColor: "#CF0000",
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
            top: 64,
            bottom: 0,
          }}
        >
          <div style={{ position: "" }}>
            <div
              style={{
                width: "100%",
                fontWeight: "600",
                fontSize: "large",
                marginBottom: "0.5rem",
                cursor: "pointer",
                color: "#666",
                ":hover": {
                  color: "white",
                  backgroundColor: "#CF0000",
                },
              }}
            >
              {menu.map((el) => {
                return (
                  <div
                    style={{
                      paddingLeft: "1rem",
                      paddingRight: "1rem",
                      paddingTop: "0.5rem",
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "18px",
                    }}
                    onClick={() => setMenu(el?.menu_code)}
                  >
                    <Tooltip
                      title={el?.en_name}
                      overlayInnerStyle={{
                        color: "#CF0000",
                        fontWeight: "bold",
                      }}
                      placement="right"
                      color="#F7D1D2"
                    >
                      {isMenu === el?.menu_code ? (
                        <button
                          style={{
                            backgroundColor: "#F7D1D2",
                            padding: "8px",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "12px",
                          }}
                        >
                          {el.menu_code === "dashboard" ? (
                            <DashboardActive />
                          ) : el.menu_code === "admin" ? (
                            <AdminActive />
                          ) : el.menu_code === "setup" ? (
                            <SetupActive />
                          ) : el?.menu_code === "master" ? (
                            <MasterActive />
                          ) : el?.menu_code === "order" ? (
                            <OrderActive />
                          ) : el?.menu_code === "report" ? (
                            <ReportActive />
                          ) : (
                            <></>
                          )}
                        </button>
                      ) : (
                        <button style={{ padding: "8px" }}>
                          {el.menu_code === "dashboard" ? (
                            <LogoMaster />
                          ) : el.menu_code === "admin" ? (
                            <LogoAdmin />
                          ) : el.menu_code === "setup" ? (
                            <img src={SetupIcon} alt="setup" />
                          ) : el?.menu_code === "master" ? (
                            <img src={MasterIcon} alt="master" />
                          ) : el?.menu_code === "order" ? (
                            <img src={OrderIcon} alt="order" />
                          ) : el?.menu_code === "report" ? (
                            <img src={ReportIcon} alt="report" />
                          ) : (
                            <></>
                          )}
                        </button>
                      )}
                    </Tooltip>
                  </div>
                );
              })}
            </div>
          </div>
        </Sider>
      </div>
      {isChecked === true ? (
        <div style={{ width: "256px" }}>
          <Sider
            collapsed={true}
            theme="light"
            width={"512px"}
            collapsedWidth={"256px"}
            style={{
              backgroundColor: "white",
              overflow: "auto",
              height: "100vh",
              position: "fixed",
              left: 72,
              top: 64,
              bottom: 0,
            }}
          >
            {isMenu === "admin" ? (
              <>
                <div className="p-4 text-red-100 font-semibold text-xl border-b-red-100 border-b-2 mr-2 ml-2">
                  Admin
                </div>
                <div
                  className={`flex justify-between p-1 mt-1 mb-1 ${
                    subMenu === "user_management"
                      ? "bg-pink-100 rounded-full"
                      : "bg-white-100"
                  } cursor-pointer`}
                  onClick={() => selectSubMenu("user_management")}
                >
                  <div className="flex gap-[10px]">
                    <img
                      width={25}
                      src={
                        subMenu === "user_management"
                          ? UserManagementIcon
                          : UserManagementIconInactive
                      }
                      alt="umicon"
                    />
                    <div
                      className={`${
                        subMenu === "user_management"
                          ? "text-red-100"
                          : "text-[#424242]"
                      } font-semibold text-[17px]`}
                    >
                      User Management
                    </div>
                  </div>
                  <img
                    src={
                      subMenu === `user_management`
                        ? ChevronUpSidebar
                        : ChevronDownSidebar
                    }
                    alt="umicon"
                    className="ml-10"
                  />
                </div>

                <div
                  className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                    subMenu === "user_management" ? "max-h-40" : "max-h-0"
                  }`}
                >
                  {/* <Link to={ROUTES.USER.LIST}> */}
                  <div
                    onClick={() => actionLeave(ROUTES.USER.LIST)}
                    className={
                      location.pathname === ROUTES.USER.LIST
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    User
                  </div>
                  {/* </Link> */}

                  {/* <Link to={ROUTES.ROLE.LIST}> */}
                  <div
                    onClick={() => actionLeave(ROUTES.ROLE.LIST)}
                    className={
                      location.pathname === ROUTES.ROLE.LIST
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Role
                  </div>
                  {/* </Link> */}

                  {/* <Link to={ROUTES.DATA_GROUP.LIST}> */}
                  <div
                    onClick={() => actionLeave(ROUTES.DATA_GROUP.LIST)}
                    className={
                      location.pathname === ROUTES.DATA_GROUP.LIST
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Data Group
                  </div>
                  {/* </Link> */}
                </div>
              </>
            ) : isMenu === "setup" ? (
              <>
                <div className="p-4 text-red-100 font-semibold text-xl border-b-red-100 border-b-2 mr-2 ml-2">
                  Setup
                </div>
                <div
                  className={`flex justify-between p-1 mt-1 mb-1 ${
                    subMenu === "profile_config"
                      ? "bg-pink-100 rounded-full"
                      : "bg-white-100"
                  } cursor-pointer`}
                  onClick={() => selectSubMenu("profile_config")}
                >
                  <div className="flex gap-[10px]">
                    <img
                      width={25}
                      src={
                        subMenu === "profile_config"
                          ? ProfileConfigurationIconRed
                          : ProfileConfigurationIcon
                      }
                      alt="umicon"
                    />
                    <div
                      className={`ml-2 ${
                        subMenu === "profile_config"
                          ? "text-red-100"
                          : "text-[#424242]"
                      } font-semibold text-lg`}
                    >
                      Profile Config
                    </div>
                  </div>
                  <img
                    src={
                      subMenu === `profile_config`
                        ? ChevronUpSidebar
                        : ChevronDownSidebar
                    }
                    alt="umicon"
                    className="ml-10"
                  />
                </div>

                <div
                  className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                    subMenu === "profile_config" ? "max-h-[300px]" : "max-h-0"
                  }`}
                >
                  {/* <Link to={ROUTES.COMPANY_PROFILE.DETAIL}> */}
                  <div
                    onClick={() => actionLeave(ROUTES.COMPANY_PROFILE.DETAIL)}
                    className={
                      location.pathname === ROUTES.COMPANY_PROFILE.DETAIL
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Company Profile
                  </div>
                  {/* </Link> */}

                  {/* <Link
                  to={`/setup/profile-configuration/address-format-configuration`}
                > */}
                  <div
                    onClick={() =>
                      actionLeave(ROUTES.ADDRESS_FORMAT_CONFIG.LIST)
                    }
                    className={
                      location.pathname ===
                      "/setup/profile-configuration/address-format-configuration"
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Address Format Configuration
                  </div>
                  {/* </Link> */}

                  {/* <Link to={`/setup/profile-configuration/system-parameters`}> */}
                  <div
                    onClick={() => actionLeave(ROUTES.PARAMETER.LIST)}
                    className={
                      location.pathname ===
                      "/setup/profile-configuration/system-parameters"
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    System Parameters
                  </div>
                  {/* </Link> */}

                  {/* <Link to={`/setup/profile-configuration/unit-of-measurement`}> */}
                  <div
                    onClick={() => actionLeave(ROUTES.UOM.LIST)}
                    className={
                      location.pathname ===
                      "/setup/profile-configuration/unit-of-measurement"
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Units of Measurement
                  </div>
                  {/* </Link> */}

                  {/* <Link to={ROUTES.TEMPERATURE_CATEGORY.LIST}> */}
                  <div
                    onClick={() =>
                      actionLeave(ROUTES.TEMPERATURE_CATEGORY.LIST)
                    }
                    className={
                      location.pathname.includes(
                        ROUTES.TEMPERATURE_CATEGORY.LIST
                      )
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Temperature Category
                  </div>
                  {/* </Link> */}

                  {/* <Link to={`/setup/profile-configuration/additional-proofs`}> */}
                  <div
                    onClick={() => actionLeave(ROUTES.ADDITIONAL_PROOFS.LIST)}
                    className={
                      location.pathname ===
                      "/setup/profile-configuration/additional-proofs"
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Additional Proofs
                  </div>
                  {/* </Link> */}
                  <div
                    onClick={() => actionLeave(ROUTES.DELIVERY_TYPE.LIST)}
                    className={
                      location.pathname === ROUTES.DELIVERY_TYPE.LIST
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Delivery Type
                  </div>
                </div>

                <div
                  onClick={() => actionLeave(ROUTES.DEPOT_CONFIG.LIST)}
                  className="flex p-1 mt-1 mb-1 "
                >
                  <img src={DepotConfigurationIcon} alt="umicon" />
                  <div className=" cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1">
                    Depot Configuration
                  </div>
                </div>
              </>
            ) : isMenu === "master" ? (
              <>
                <div className="p-4 text-red-100 font-semibold text-xl border-b-red-100 border-b-2 mr-2 ml-2">
                  Master
                </div>
                <div
                  onClick={() => actionLeave(ROUTES.CUSTOMER.LIST)}
                  className="flex p-1 mt-1 rounded-full cursor-pointer"
                >
                  <img src={IconCustomer} alt="umicon" />
                  <div className="ml-2 font-semibold text-lg">Customer</div>
                </div>
                <div
                  onClick={() => actionLeave(ROUTES.SELLER.LIST)}
                  className="flex p-1 mt-1 rounded-full cursor-pointer"
                >
                  <img src={IconSellerDistributor} alt="umicon" />
                  <div className="ml-2 font-semibold text-lg">Seller</div>
                </div>
                <div
                  className={`flex justify-between p-1 mt-1 mb-1 ${
                    subMenu === "fleet"
                      ? "bg-pink-100 rounded-full"
                      : "bg-white-100"
                  } cursor-pointer`}
                  onClick={() => selectSubMenu("fleet")}
                >
                  <div className="flex gap-[10px]">
                    <img
                      width={25}
                      src={subMenu === "fleet" ? IconFleetRed : IconFleet}
                      alt="umicon"
                    />
                    <div
                      className={`ml-2 ${
                        subMenu === "fleet" ? "text-red-100" : "text-[#424242]"
                      } font-semibold text-lg`}
                    >
                      Fleet
                    </div>
                  </div>
                  <img
                    src={
                      subMenu === `fleet`
                        ? ChevronUpSidebar
                        : ChevronDownSidebar
                    }
                    alt="umicon"
                    className="ml-10"
                  />
                </div>

                <div
                  className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                    subMenu === "fleet" ? "max-h-60" : "max-h-0"
                  }`}
                >
                  <div
                    onClick={() => actionLeave(ROUTES.DELIVERY_ASSOCIATE.LIST)}
                    className={
                      location.pathname === ROUTES.DELIVERY_ASSOCIATE.LIST ||
                      location.pathname === ROUTES.DELIVERY_ASSOCIATE.ADD ||
                      location.pathname === ROUTES.DELIVERY_ASSOCIATE.EDIT ||
                      location.pathname === ROUTES.DELIVERY_ASSOCIATE.DETAIL
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Delivery Associate
                  </div>
                  <div
                    onClick={() => actionLeave(ROUTES.VEHICLE.LIST)}
                    className={
                      location.pathname === ROUTES.VEHICLE.LIST
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Vehicle
                  </div>
                  <div
                    onClick={() => actionLeave(ROUTES.DRIVER.LIST)}
                    className={
                      location.pathname === ROUTES.DRIVER.LIST
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Driver
                  </div>
                  <div
                    onClick={() => actionLeave(ROUTES.SKILLSET.LIST)}
                    className={
                      location.pathname === ROUTES.SKILLSET.LIST
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Skillset
                  </div>
                  <div
                    onClick={() => actionLeave(ROUTES.PALLET.LIST)}
                    className={
                      location.pathname === ROUTES.PALLET.LIST
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Pallet
                  </div>
                </div>
              </>
            ) : isMenu === "order" ? (
              <>
                <div className="p-4 text-red-100 font-semibold text-xl border-b-red-100 border-b-2 mr-2 ml-2">
                  Order
                </div>
                <div
                  onClick={() => actionLeave(ROUTES.ORDER_REQUEST.LIST)}
                  className="flex p-1 mt-1 rounded-full cursor-pointer"
                >
                  <img src={IconOrderRequest} alt="umicon" />
                  <div className="ml-2 font-semibold text-lg">
                    Order Request
                  </div>
                </div>
                <div
                  onClick={() => actionLeave(ROUTES.GROMART_ORDER.LIST)}
                  className="flex p-1 mt-1 rounded-full cursor-pointer"
                >
                  <img src={IconGromartOrder} alt="umicon" />
                  <div className="ml-2 font-semibold text-lg">
                    Gromart Order
                  </div>
                </div>

                <div
                  className={`flex justify-between p-1 mt-1 mb-1 ${
                    subMenu === "routes"
                      ? "bg-pink-100 rounded-full"
                      : "bg-white-100"
                  } cursor-pointer`}
                  onClick={() => selectSubMenu("routes")}
                >
                  <div className="flex gap-[10px]">
                    <img
                      width={25}
                      src={subMenu === "routes" ? RoutesIconRed : RoutesIcon}
                      alt="umicon"
                    />
                    <div
                      className={`ml-2 ${
                        subMenu === "routes" ? "text-red-100" : "text-[#424242]"
                      } font-semibold text-lg`}
                    >
                      Routes
                    </div>
                  </div>
                  <img
                    src={
                      subMenu === `routes`
                        ? ChevronUpSidebar
                        : ChevronDownSidebar
                    }
                    alt="umicon"
                    className="ml-10"
                  />
                </div>

                <div
                  className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                    subMenu === "routes" ? "max-h-40" : "max-h-0"
                  }`}
                >
                  <div
                    onClick={() => actionLeave(ROUTES.TRIP_PLANNING.LIST)}
                    className={
                      location.pathname === ROUTES.TRIP_PLANNING.LIST ||
                      location.pathname === ROUTES.TRIP_PLANNING.DETAIL ||
                      location.pathname === ROUTES.TRIP_PLANNING.DETAIL2 ||
                      location.pathname === ROUTES.TRIP_PLANNING.ADD
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Trip Planning
                  </div>
                  <div
                    onClick={() => actionLeave(ROUTES.ALL_TRIP.LIST)}
                    className={
                      location.pathname === ROUTES.ALL_TRIP.LIST ||
                      location.pathname === ROUTES.ALL_TRIP.DETAIL ||
                      location.pathname === ROUTES.ALL_TRIP.ADD ||
                      location.pathname === ROUTES.ALL_TRIP.EDIT
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    All Trip
                  </div>
                </div>

                <div
                  onClick={() => actionLeave(ROUTES.SHIPPING_COST_PAYMENT.LIST)}
                  className="flex p-1 mt-1 rounded-full cursor-pointer"
                >
                  <img src={IconShippingCostPayment} alt="umicon" />
                  <div className="ml-2 font-semibold text-lg">
                    Shipping Cost Payment
                  </div>
                </div>

                <div
                  onClick={() => actionLeave(ROUTES.BILLING_INVOICE.REPORT)}
                  className="flex p-1 mt-1 rounded-full cursor-pointer"
                >
                  <img src={IconInvoice} alt="umicon" />
                  <div className="ml-2 font-semibold text-lg">Invoice</div>
                </div>
              </>
            ) : isMenu === "report" ? (
              <>
                <div className="p-4 text-red-100 font-semibold text-xl border-b-red-100 border-b-2 mr-2 ml-2">
                  Report
                </div>
                <div
                  onClick={() => actionLeave(ROUTES.LOG_REPORT.LIST)}
                  className="flex p-1 mt-1 rounded-full cursor-pointer"
                >
                  <img src={IconLogReport} alt="umicon" />
                  <div className="ml-2 font-semibold text-lg"> Log Report </div>
                </div>
                <div
                  className={`flex justify-between p-1 mt-1 mb-1 ${
                    subMenu === "report"
                      ? "bg-pink-100 rounded-full"
                      : "bg-white-100"
                  } cursor-pointer`}
                  onClick={() => selectSubMenu("report")}
                >
                  <div className="flex gap-[10px]">
                    <img
                      width={25}
                      src={subMenu === "report" ? IconReportRed : IconReport}
                      alt="umicon"
                    />
                    <div
                      className={`ml-2 ${
                        subMenu === "report" ? "text-red-100" : "text-[#424242]"
                      } font-semibold text-lg`}
                    >
                      Report
                    </div>
                  </div>
                  <img
                    src={
                      subMenu === `report`
                        ? ChevronUpSidebar
                        : ChevronDownSidebar
                    }
                    alt="umicon"
                    className="ml-10"
                  />
                </div>
                <div
                  className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                    subMenu === "report" ? "max-h-40" : "max-h-0"
                  }`}
                >
                  <div
                    onClick={() => actionLeave(ROUTES.REPORT_ORDER.LIST)}
                    className={
                      location.pathname === ROUTES.REPORT_ORDER.LIST
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Order
                  </div>
                  <div
                    onClick={() =>
                      actionLeave(ROUTES.REPORT_DELIVERY_ASSOCIATE.LIST)
                    }
                    className={
                      location.pathname ===
                      ROUTES.REPORT_DELIVERY_ASSOCIATE.LIST
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Delivery Associate
                  </div>
                  <div
                    onClick={() => actionLeave(ROUTES.REPORT_TRIP.LIST)}
                    className={
                      location.pathname === ROUTES.REPORT_TRIP.LIST
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Trip
                  </div>
                  <div
                    onClick={() => actionLeave(ROUTES.REPORT_DEPOT.LIST)}
                    className={
                      location.pathname === ROUTES.REPORT_DEPOT.LIST
                        ? "p-1 mt-1 mb-1 bg-pink-100 rounded-full pl-12 text-red-100 font-semibold text-lg cursor-pointer"
                        : "cursor-pointer text-gray-100  font-semibold text-lg p-1 mt-1 mb-1 ml-12"
                    }
                  >
                    Depot
                  </div>
                </div>
              </>
            ) : isMenu === "dashboard" ? (
              <>
                <div className="p-4 text-red-100 font-semibold text-xl border-b-red-100 border-b-2 mr-2 ml-2">
                  Dashboard
                </div>
                <div
                  onClick={() => actionLeave(ROUTES.DASHBOARD)}
                  className="flex p-1 mt-1 rounded-full cursor-pointer"
                >
                  <img src={UserManagementIcon} alt="umicon" />
                  <div className="ml-2 font-semibold text-lg"> Dashboard </div>
                </div>
              </>
            ) : null}
          </Sider>
        </div>
      ) : null}
    </>
  );
};
